import { useGrowthBook } from '@growthbook/growthbook-react';

export const useIsGrowthbookReady = () => {
  const gb = useGrowthBook();
  return gb.ready && !!Object.keys(gb.getAttributes()).length;
};
